class ZonedTime {
    time;
    zone;
    constructor(response) {
        this.time = response.time;
        this.zone = response.zone;
    }
    print() {
        const items = [];
        if (this.time !== undefined) {
            items.push(this.time.substring(0, 5));
            items.push(this.zone);
        }
        return items;
    }
}
export default ZonedTime;
